module.exports = __webpack_public_path__ + "img/commission.15b5e9c5.svg";